import Vue from 'vue';
import QuestionButtons from '@/components/Questions/QuestionButtons.vue';
import QuestionInput from '@/components/Questions/QuestionInput.vue';

Vue.component('QuestionButtons', QuestionButtons);
Vue.component('QuestionInput', QuestionInput);
